function checkAndClearCart() {
  const $rows = $(".cart-items__table tbody tr");
  const rowClasses = $rows
    .map(function () {
      return $(this).attr("class") || "";
    })
    .get();

  const TARGET_CLASSES = [
    "hide-42681208668325 cart-items__table-row",
    "hide-47772981133477 cart-items__table-row",
    "hide-47634122735781 cart-items__table-row",
  ];

  const matchCount = rowClasses.filter((cls) =>
    TARGET_CLASSES.includes(cls),
  ).length;

  // ✅ Condition:
  //  - if only 1 item & it's one of the targets → true
  //  - if 2 items & both are targets → true
  if (
    (rowClasses.length === 1 && matchCount === 1) ||
    (rowClasses.length === 2 && matchCount === 2) ||
    (rowClasses.length === 3 && matchCount === 3)
  ) {
    console.log("✅ Matching condition found. Clearing cart...");
    console.log("Test", rowClasses);
    clearCart(); // 🔹 Your custom function to clear cart
  } else {
    console.log("❌ Condition not met. No action taken.");
    document.body.classList.remove("cartLoaderActive");
  }
}

// Track /cart/add.js so interval enforcement doesn't race multi-request adds.
if (!window.__subscriptionEnforcerWrappedFetch) {
  window.__subscriptionEnforcerWrappedFetch = true;
  window.__subscriptionEnforcerAddInFlight = 0;
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const url = typeof input === "string" ? input : input?.url;
    const isCartAdd = typeof url === "string" && url.includes("/cart/add");
    if (isCartAdd) window.__subscriptionEnforcerAddInFlight++;
    const p = originalFetch(input, init);
    if (!isCartAdd) return p;
    return p.finally(() => {
      window.__subscriptionEnforcerAddInFlight = Math.max(
        0,
        window.__subscriptionEnforcerAddInFlight - 1,
      );
    });
  };
}

async function addSubscriptionIfQualifyingAdded() {
  try {
    const cart = await getCart();
    if (!cart.items || cart.items.length === 0) return;

    const hasQualifying = cart.items.some(
      (item) =>
        QUALIFYING_PRODUCT_IDS.some(
          (pid) => String(item.product_id) === String(pid),
        ) && item.selling_plan_allocation != null,
    );
    console.log(
      "hasQualifying:",
      hasQualifying,
      "QUALIFYING_PRODUCT_IDS:",
      QUALIFYING_PRODUCT_IDS,
    );

    if (!hasQualifying) return;

    const hasSubscription = cart.items.some(
      (item) =>
        String(item.product_id) === String(SUBSCRIPTION_PRODUCT_ID) &&
        item.selling_plan_allocation != null,
    );
    console.log("hasSubscription:", hasSubscription);
    if (hasSubscription) return;

    console.log("Adding subscription product...");

    await window.BotaniqueAutoCart?.enqueue({
      source: "auto-subscription-add",
      addItems: [
        {
          id: 47519922389157,
          quantity: 1,
          selling_plan: 3929178277,
        },
      ],
    });
    console.log("Subscription added successfully");
  } catch (err) {
    console.error("Auto-add subscription error:", err);
  }
}

const SUBSCRIPTION_PRODUCT_ID = 10493180379301;
const QUALIFYING_PRODUCT_IDS = [10535999537317];
const SUBSCRIPTION_CORRECTION_SOURCE = "subscription-correction";

const FREE_PDF_PRODUCT_IDS = [10557468278949, 10518978658469];
// const WARRANTY_PRODUCT_IDS = [10463100666021, 8315446067365];

const CONTOURA_UPSELL_PRODUCT_ID = 10584817402021;
const REVITALEYES_PRODUCT_HANDLES = [
  "revitaleyes",
  "revitaleyes-for-men",
  "revitaleyes-1",
  "revitaleyes-for-eye-bags",
  "revitaleyes®-2-in-1-red-light-therapy-ems-to-erase-eye-bags-age-20-29",
  "revitaleyes®-2-in-1-red-light-therapy-ems-to-erase-eye-bags-age-30-39",
  "revitaleyes®-2-in-1-red-light-therapy-ems-to-erase-eye-bags-age-40-49",
  "revitaleyes®-2-in-1-red-light-therapy-ems-to-erase-eye-bags-age-50-59",
  "revitaleyes-men-cream",
  "revitaleyes-eye-cream"
];
const CONTOURA_UPSELL_CORRECTION_SOURCE = "contoura-upsell-correction";

function getCart(options = {}) {
  if (window.BotaniqueCartCache?.getCart) {
    return window.BotaniqueCartCache.getCart(options);
  }

  return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(
    (r) => r.json(),
  );
}

// Interval-only: require cart to be stable across 2 ticks before removing free-only items.
let __subscriptionEnforcerLastIntervalSignature = null;

function resolveCartChangeUrl() {
  const root = window.Shopify?.routes?.root;
  if (root) return `${root}cart/change.js`;
  const themeChange = window.Theme?.routes?.cart_change_url;
  if (themeChange) {
    return themeChange.endsWith(".js") ? themeChange : `${themeChange}.js`;
  }
  return "/cart/change.js";
}

function resolveCartClearUrl() {
  const root = window.Shopify?.routes?.root;
  if (root) return `${root}cart/clear.js`;
  const cartUrl = window.Theme?.routes?.cart_url || "/cart";
  return `${cartUrl}/clear.js`;
}

/**
 * @param {Record<string, number>} updates
 * @param {{ sections?: string }} [opts]
 */
async function batchChangeCartLineQuantities(updates, opts = {}) {
  const entries = Object.entries(updates).filter(
    ([key, qty]) => key && key !== "undefined" && typeof qty === "number",
  );
  if (entries.length === 0) return null;

  if (window.BotaniqueAutoCart?.enqueue) {
    const data = await window.BotaniqueAutoCart.enqueue({
      source: opts.source || SUBSCRIPTION_CORRECTION_SOURCE,
      changes: entries.map(([lineKey, qty]) => ({
        id: lineKey,
        quantity: qty,
      })),
    });
    return data ? { ...data, __autoCartHandled: true } : data;
  }

  let last = null;
  for (const [lineKey, qty] of entries) {
    /** @type {{ id: string, quantity: number, sections?: string, sections_url?: string }} */
    const payload = { id: lineKey, quantity: qty };
    if (opts.sections) {
      payload.sections = opts.sections;
      payload.sections_url = window.location.pathname;
    }

    const res = await fetch(resolveCartChangeUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });
    last = await res.json();
    if (last?.errors || last?.message) break;
  }
  return last;
}
/**
 * @param {{ trigger?: "cart-update" | "interval" | "quantity-finally" | "load" }} [opts]
 */
async function enforceSubscriptionQuantityRule(opts = {}) {
  const trigger = opts.trigger ?? "cart-update";
  try {
    const cart = await getCart();
    if (!cart.items || cart.items.length === 0) return;

    const subscriptionItems = cart.items
      .map((item, idx) => ({ item, line: idx + 1 }))
      .filter(
        ({ item }) =>
          String(item.product_id) === String(SUBSCRIPTION_PRODUCT_ID),
      );

    const qualifyingItems = cart.items.filter((item) =>
      QUALIFYING_PRODUCT_IDS.some(
        (pid) => String(item.product_id) === String(pid),
      ),
    );

    const subscriptionQty = subscriptionItems.reduce(
      (sum, { item }) => sum + (item.quantity || 0),
      0,
    );
    const qualifyingQty = qualifyingItems.reduce(
      (sum, item) => sum + (item.quantity || 0),
      0,
    );

    const maxAllowed = qualifyingQty;
    if (subscriptionQty <= maxAllowed) return;

    // Zero-qualifying + free present is frequently a race right after add-to-cart.
    // We NEVER remove on cart:update (any source). We only remove:
    // - on 20s interval (orphan freebies)
    // - after cart quantity edits (quantity-finally)
    if (maxAllowed === 0 && subscriptionQty > 0) {
      const addInFlight = Number(window.__subscriptionEnforcerAddInFlight || 0);
      const intervalSignature =
        trigger === "interval"
          ? cart.items
              .map((it) => `${it.key}:${it.quantity}`)
              .sort()
              .join("|")
          : null;

      // Only remove free subscription items, not paid ones
      const hasFreeSubscription = subscriptionItems.some(
        ({ item }) => (item.price || 0) === 0,
      );
      if (!hasFreeSubscription) return;

      // If the cart is still changing (e.g. bundle adds qualifying in a later request),
      // don't remove on the first interval tick. Only remove if the cart is unchanged across 2 ticks.
      if (trigger === "interval" && addInFlight === 0) {
        const wasSame =
          __subscriptionEnforcerLastIntervalSignature === intervalSignature;
        __subscriptionEnforcerLastIntervalSignature = intervalSignature;
        if (!wasSame) return;
      }

      const allowZeroQualifyingRemoval =
        trigger === "quantity-finally" ||
        (trigger === "interval" && addInFlight === 0) ||
        (trigger === "load" && addInFlight === 0);
      if (!allowZeroQualifyingRemoval) return;
    }

    const freeSubscriptionItems = subscriptionItems.filter(
      ({ item }) => (item.price || 0) === 0,
    );
    const freeSubscriptionQty = freeSubscriptionItems.reduce(
      (sum, { item }) => sum + (item.quantity || 0),
      0,
    );
    const toRemove = freeSubscriptionQty - maxAllowed;
    let removed = 0;

    document.body.classList.add("cartLoaderActive");

    const cartItemsComponents = document.querySelectorAll(
      "cart-items-component",
    );
    const sectionsToUpdate = new Set();
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionsToUpdate.add(el.dataset.sectionId);
      }
    });
    const sections = Array.from(sectionsToUpdate).join(",");

    /** @type {Record<string, number>} */
    const batchUpdates = {};
    /** @type {Array<{ item: object, line: number, newQty: number }>} */
    const fallbackChanges = [];

    for (
      let i = freeSubscriptionItems.length - 1;
      i >= 0 && removed < toRemove;
      i--
    ) {
      const { item, line: lineIndex } = freeSubscriptionItems[i];
      const currentQty = item.quantity || 0;
      const reduceBy = Math.min(currentQty, toRemove - removed);
      const newQty = currentQty - reduceBy;
      removed += reduceBy;

      const lineKey = item.key != null ? String(item.key) : null;
      if (lineKey) {
        batchUpdates[lineKey] = newQty;
      } else {
        fallbackChanges.push({ item, line: lineIndex, newQty });
      }
    }

    let lastSections = null;
    let lastItemCount = 0;
    let hadErrors = false;

    if (Object.keys(batchUpdates).length > 0) {
      const data = await batchChangeCartLineQuantities(batchUpdates, {
        sections,
      });
      if (data?.errors || data?.message) {
        console.error("Subscription enforcer:", data.errors);
        hadErrors = true;
      } else if (!data?.__autoCartHandled && data?.sections) {
        lastSections = data.sections;
        lastItemCount = data.item_count;
      }
    }

    if (!hadErrors) {
      for (const { item, line: lineIndex, newQty } of fallbackChanges) {
        const lineParam = item.key != null ? String(item.key) : null;
        const payload =
          lineParam != null
            ? {
                id: lineParam,
                quantity: newQty,
                sections,
                sections_url: window.location.pathname,
              }
            : {
                line: lineIndex,
                quantity: newQty,
                sections,
                sections_url: window.location.pathname,
              };

        const data = window.BotaniqueAutoCart?.enqueue
          ? await window.BotaniqueAutoCart.enqueue({
              source: SUBSCRIPTION_CORRECTION_SOURCE,
              changes: [
                {
                  id: lineParam,
                  line: lineParam == null ? lineIndex : undefined,
                  quantity: newQty,
                },
              ],
            }).then((result) =>
              result ? { ...result, __autoCartHandled: true } : result,
            )
          : await fetch(resolveCartChangeUrl(), {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(payload),
            }).then((res) => res.json());

        if (data.errors || data.message) {
          console.error("Subscription enforcer:", data.errors);
          hadErrors = true;
          break;
        }
        if (!data.__autoCartHandled) {
          lastSections = data.sections;
          lastItemCount = data.item_count;
        }
      }
    }

    if (lastSections) {
      for (const [sectionId, html] of Object.entries(lastSections)) {
        if (sectionId && html) morphSection(sectionId, html);
      }
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: {
            data: {
              itemCount: lastItemCount,
              sections: lastSections,
              source: SUBSCRIPTION_CORRECTION_SOURCE,
            },
          },
        }),
      );
    }

    document.body.classList.remove("cartLoaderActive");
  } catch (err) {
    document.body.classList.remove("cartLoaderActive");
    console.error("Subscription enforcer error:", err);
  }
}

async function removeFreePdfIfNoPaidItems() {
  // replaced by the removeFreePdfIfNoPaidItems in kaching-cart-micro-upsell.liquid
  return;
  try {
    const cart = await getCart();
    if (!cart.items || cart.items.length === 0) return;

    console.log("=== removeFreePdfIfNoPaidItems ===");
    console.log(
      "Cart items:",
      cart.items.map((i) => ({
        id: i.id,
        product_id: i.product_id,
        variant_id: i.variant_id,
        price: i.price,
        title: i.title,
      })),
    );

    const freePdfItems = cart.items.filter((item) =>
      FREE_PDF_PRODUCT_IDS.some(
        (pid) => String(item.product_id) === String(pid),
      ),
    );

    if (freePdfItems.length === 0) return;

    const paidItems = cart.items.filter((item) => {
      if (
        FREE_PDF_PRODUCT_IDS.some(
          (pid) => String(item.product_id) === String(pid),
        )
      )
        return false;
      if (
        WARRANTY_PRODUCT_IDS.some(
          (pid) => String(item.product_id) === String(pid),
        )
      )
        return false;
      return (item.price || 0) > 0;
    });

    if (paidItems.length === 0) {
      document.body.classList.add("cartLoaderActive");

      const res = await fetch(resolveCartClearUrl(), {
        method: "POST",
        headers: { Accept: "application/json" },
      });
      const data = await res.json();

      if (!data?.errors && !data?.message && data?.sections) {
        for (const [sectionId, html] of Object.entries(data.sections)) {
          if (sectionId && html) morphSection(sectionId, html);
        }
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            detail: {
              data: {
                itemCount: data.item_count,
                sections: data.sections,
                source: "free-pdf-removal",
              },
            },
          }),
        );
      }

      document.body.classList.remove("cartLoaderActive");
    }
  } catch (err) {
    document.body.classList.remove("cartLoaderActive");
    console.error("Free PDF removal error:", err);
  }
}

async function enforceContouraUpsellRule(opts = {}) {
  const trigger = opts.trigger ?? "cart-update";

  if (opts.cartUpdateSource === CONTOURA_UPSELL_CORRECTION_SOURCE) return;

  try {
    const cart = await getCart();
    if (!cart.items || cart.items.length === 0) return;

    const upsellItem = cart.items.find(
      (item) => String(item.product_id) === String(CONTOURA_UPSELL_PRODUCT_ID),
    );

    if (!upsellItem) return;

    const upsellQty = upsellItem.quantity || 0;
    const upsellKey = upsellItem.key;

    const hasRevitaleyes = cart.items.some((item) =>
      REVITALEYES_PRODUCT_HANDLES.some(
        (handle) =>
          (item.handle && item.handle === handle) ||
          (item.properties && item.properties._handle === handle),
      ),
    );

    let newQty = null;
    if (!hasRevitaleyes) {
      newQty = 0;
      console.log("Contoura upsell: no revitaleyes found, removing...");
    } else if (upsellQty > 1) {
      newQty = 1;
      console.log(`Contoura upsell: qty ${upsellQty} > 1, reducing to 1`);
    }

    if (newQty === null) return;

    document.body.classList.add("cartLoaderActive");

    const cartItemsComponents = document.querySelectorAll(
      "cart-items-component",
    );
    const sectionsToUpdate = new Set();
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionsToUpdate.add(el.dataset.sectionId);
      }
    });
    const sections = Array.from(sectionsToUpdate).join(",");

    const lineParam = upsellKey != null ? String(upsellKey) : null;
    const lineIndex = cart.items.indexOf(upsellItem) + 1;

    const payload =
      lineParam != null
        ? {
            id: lineParam,
            quantity: newQty,
            sections,
            sections_url: window.location.pathname,
          }
        : {
            line: lineIndex,
            quantity: newQty,
            sections,
            sections_url: window.location.pathname,
          };

    const data = window.BotaniqueAutoCart?.enqueue
      ? await window.BotaniqueAutoCart.enqueue({
          source: CONTOURA_UPSELL_CORRECTION_SOURCE,
          changes: [
            {
              id: lineParam,
              line: lineParam == null ? lineIndex : undefined,
              quantity: newQty,
            },
          ],
        }).then((result) =>
          result ? { ...result, __autoCartHandled: true } : result,
        )
      : await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }).then((res) => res.json());

    if (!data.__autoCartHandled && !data.errors && data.sections) {
      for (const [sectionId, html] of Object.entries(data.sections)) {
        if (sectionId && html) morphSection(sectionId, html);
      }
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: {
            data: {
              itemCount: data.item_count,
              sections: data.sections,
              source: CONTOURA_UPSELL_CORRECTION_SOURCE,
            },
          },
        }),
      );
    }

    document.body.classList.remove("cartLoaderActive");
  } catch (err) {
    document.body.classList.remove("cartLoaderActive");
    console.error("Contoura upsell enforcement error:", err);
  }
}

function clearCart() {
  if (window.BotaniqueAutoCart?.enqueue) {
    getCart({ force: true })
      .then((cart) => {
        const changes = (cart.items || []).map((item, index) => ({
          id: item.key != null ? String(item.key) : undefined,
          line: item.key == null ? index + 1 : undefined,
          quantity: 0,
        }));
        if (changes.length === 0) return null;
        return window.BotaniqueAutoCart.enqueue({
          source: "free-only-cart-clear",
          changes,
        });
      })
      .catch((error) => {
        console.error("Queued cart clear failed:", error);
        document.body.classList.remove("cartLoaderActive");
      });
    return;
  }

  // Example: Shopify AJAX cart clear
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      const cartDrawerHTML = `<div class="cart-drawer__header"><button ref="closeButton" on:click="cart-drawer-component/close" class="button close-button cart-drawer__close-button button-unstyled" aria-label="Close dialog"><span class="svg-wrapper"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></button></div><div class="cart-drawer__content motion-reduce" aria-label="Cart"><span class="cart-drawer__heading h3 cart-drawer__heading--empty">Your bag is empty</span><div class="cart-drawer__items"><script src="//botaniqueparis.com/cdn/shop/t/123/assets/component-cart-items.js?v=140871224529339158381762552370" type="module" fetchpriority="low"></script><div class="cart-items__wrapper"><p>Have an account? <a href="https://botaniqueparis.com/customer_authentication/redirect?locale=en&amp;region_country=IN">Log in</a> to check out faster.</p><a class="button cart-items__empty-button" href="/collections/radiance-collection">Continue shopping</a></div></div></div>`;

      const target = document.querySelector(".cart-items-component");
      if (target) {
        // Replace cart drawer HTML
        target.innerHTML = cartDrawerHTML;

        // Update cart bubble
        const bubble = document.querySelector(".cart-bubble");
        if (bubble) {
          bubble.innerHTML = `<span class="cart-bubble__background"></span><span ref="cartBubbleText" class="cart-bubble__text" role="status"><span class="visually-hidden">Total items in cart: 0</span><span class="cart-bubble__text-count hidden" ref="cartBubbleCount" aria-hidden="true" data-testid="cart-bubble">0</span></span>`;
          bubble.classList.add("hidden"); // 👈 main cart-bubble par hidden class add
        }

        // Remove has-cart class from header icon
        const headerCartIcon = document.querySelector(
          ".header-actions__cart-icon",
        );
        if (headerCartIcon) {
          headerCartIcon.classList.remove(
            "header-actions__cart-icon--has-cart",
          );
        }

        document.body.classList.remove("cartLoaderActive");
        console.log(
          "✅ Cart drawer, bubble, and header icon updated (bubble hidden)!",
        );
      }
    },
  });
}

const WARRANTY_VARIANT_ID = 42681208668325;

function updateCartTotals(response) {
  var orignalPrice = response.original_total_price;
  var totalPrice = response.total_price;
  var discountPrice = response.total_discount;

  $(".cart__total-container .cart__total:nth-child(1) text-component").text(
    "Rs. " +
      (orignalPrice / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  );
  $(".cart__total-container .cart__total:nth-child(2) text-component").text(
    "-Rs. " +
      (discountPrice / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  );
  $(".cart__total-container .cart__total:nth-child(3) text-component").text(
    "Rs. " +
      (totalPrice / 100).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  );
}

function refreshCartTotals() {
  getCart()
    .then(updateCartTotals)
    .catch((error) => {
      console.error("Cart totals refresh failed:", error);
    });
}

const handleWarrantyChange = async (_this) => {
  $("body").addClass("cartLoaderActive");

  if (_this.find("input").is(":checked")) {
    _this.find("input").prop("checked", false);
    try {
      const cart = await getCart();
      const idx = cart.items.findIndex((i) => i.id === WARRANTY_VARIANT_ID);

      if (idx > -1) {
        const line = idx + 1;

        await $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { line, quantity: 0 },
          dataType: "json",
          success: refreshCartTotals,
          error: function (xhr, status, error) {
            console.error("❌ Error removing warranty:", error);
          },
          complete: function (response) {
            console.log(2, response);
            setTimeout(() => $("body").removeClass("cartLoaderActive"), 1000);
          },
        });
      } else {
        console.log("⚠️ Warranty item not found in cart");
        $("body").removeClass("cartLoaderActive");
      }
    } catch (error) {
      console.error("⚠️ Error:", error);
      $("body").removeClass("cartLoaderActive");
    }
  } else {
    _this.find("input").prop("checked", true);
    console.log("add");

    try {
      await $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({
          items: [{ id: WARRANTY_VARIANT_ID, quantity: 1 }],
        }),
        dataType: "json",
        contentType: "application/json",
        success: refreshCartTotals,
        error: function (xhr, status, error) {
          console.error("❌ Error adding warranty:", error);
        },
        complete: function (data) {
          console.log(4, data);
          setTimeout(() => $("body").removeClass("cartLoaderActive"), 1000);
        },
      });
    } catch (err) {
      console.error("⚠️ Error:", err);
      $("body").removeClass("cartLoaderActive");
    }
  }
  // if ($target.is(":checked")) {
  //   console.log("add");
  //   await fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({
  //       items: [{ id: WARRANTY_VARIANT_ID, quantity: 1 }],
  //       sections_url: window.location.pathname,
  //     }),
  //   })
  //     .then((r) => r.json())
  //     .then((response) => {
  //       document.dispatchEvent(
  //         new CustomEvent("cart:update", {
  //           detail: {
  //             itemCount: response.item_count,
  //             sections: response.sections,
  //             source: "warranty-toggle",
  //           },
  //         })
  //       );
  //       setTimeout(() => $("body").removeClass("cartLoaderActive"), 1000);
  //     });
  // } else {
  //   console.log("remove");
  //   const cart = await fetch("/cart.js").then((r) => r.json());
  //   const idx = cart.items.findIndex((i) => i.id === WARRANTY_VARIANT_ID);
  //   if (idx > -1) {
  //     const line = idx + 1;
  //     // ✅ Assuming updateQuantityAsync is global or defined somewhere else
  //     await updateQuantityAsync({
  //       line,
  //       quantity: 0,
  //       action: "clear",
  //     });
  //   }
  //   setTimeout(() => $("body").removeClass("cartLoaderActive"), 1000);
  // }
};

$("body").on("click", ".warranty-right", function (e) {
  e.preventDefault();
  var _this = $(this);
  handleWarrantyChange(_this);
});

import { Component } from "@theme/component";
import {
  fetchConfig,
  debounce,
  onAnimationEnd,
  prefersReducedMotion,
  resetShimmer,
} from "@theme/utilities";
import { morphSection, sectionRenderer } from "@theme/section-renderer";
import {
  ThemeEvents,
  CartUpdateEvent,
  QuantitySelectorUpdateEvent,
  CartAddEvent,
  DiscountUpdateEvent,
} from "@theme/events";
import { cartPerformance } from "@theme/performance";

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */
class CartItemsComponent extends Component {
  #debouncedOnChange = debounce(this.#onQuantityChange, 300).bind(this);
  #subscriptionEnforcerIntervalId = null;
  #enforcerCartUpdateListener = (event) => {
    if (event.detail?.data?.source === SUBSCRIPTION_CORRECTION_SOURCE) return;
    const cartUpdateSource = event.detail?.data?.source;
    setTimeout(
      () =>
        enforceSubscriptionQuantityRule({
          trigger: "cart-update",
          cartUpdateSource,
        }),
      400,
    );
  };

  #qualifyingAddedListener = (event) => {
    const source = event.detail?.data?.source;
    if (source === SUBSCRIPTION_CORRECTION_SOURCE) return;
    console.log("Qualifying listener triggered, source:", source);
    if (window.__addSubscriptionTimeout) return;
    window.__addSubscriptionTimeout = setTimeout(() => {
      window.__addSubscriptionTimeout = null;
    }, 10000);
    addSubscriptionIfQualifyingAdded().finally(() => {
      if (window.__addSubscriptionTimeout) {
        clearTimeout(window.__addSubscriptionTimeout);
        window.__addSubscriptionTimeout = null;
      }
    });
  };

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(ThemeEvents.cartUpdate, this.#handleCartUpdate);
    // NOTE: do not run enforcer on cart:update (add-to-cart race can show 0 qualifying temporarily)
    document.addEventListener(
      ThemeEvents.discountUpdate,
      this.handleDiscountUpdate,
    );
    document.addEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this.#debouncedOnChange,
    );
    document.addEventListener(
      ThemeEvents.cartUpdate,
      this.#qualifyingAddedListener,
    );
    this.#initWarrantyToggle();
    this.#initupsellToggle();
    this.#initRecommendToggle();
    enforceSubscriptionQuantityRule({ trigger: "load" });
    // removeFreePdfIfNoPaidItems();
    this.#subscriptionEnforcerIntervalId = setInterval(() => {
      enforceSubscriptionQuantityRule({ trigger: "interval" });
      // removeFreePdfIfNoPaidItems();
    }, 20000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      ThemeEvents.cartUpdate,
      this.#handleCartUpdate,
    );
    document.removeEventListener(
      ThemeEvents.cartUpdate,
      this.#qualifyingAddedListener,
    );
    document.removeEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this.#debouncedOnChange,
    );
    if (this.#subscriptionEnforcerIntervalId != null) {
      clearInterval(this.#subscriptionEnforcerIntervalId);
      this.#subscriptionEnforcerIntervalId = null;
    }
  }
  handleRecommendClick = async (variantId, btn) => {
    if (!variantId || !btn) return;
    btn.disabled = true;
    btn.classList.add("loading");

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }],
          sections: this.sectionId,
          sections_url: window.location.pathname,
        }),
      });

      const data = await res.json();

      // 🔁 Fire a cart update event so the UI refreshes and toggles re-init
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartUpdate, {
          detail: {
            data: {
              itemCount: data.item_count,
              sections: data.sections,
              source: "recommend-toggle",
            },
          },
        }),
      );
    } catch (err) {
      console.error("Recommend add failed:", err);
    } finally {
      btn.disabled = false;
      btn.classList.remove("loading");
    }
  };

  #initRecommendToggle() {
    const recommendBtns = this.querySelectorAll(".recommend-add-btn");
    if (!recommendBtns.length) return;

    recommendBtns.forEach((btn) => {
      // btn.addEventListener("click", async () => {
      //   const variantId = btn.dataset.variantId;
      //   if (!variantId) return;
      //   btn.disabled = true;
      //   btn.classList.add("loading");
      //   try {
      //     const res = await fetch("/cart/add.js", {
      //       method: "POST",
      //       headers: { "Content-Type": "application/json" },
      //       body: JSON.stringify({
      //         items: [{ id: parseInt(variantId), quantity: 1 }],
      //         sections: this.sectionId,
      //         sections_url: window.location.pathname,
      //       }),
      //     });
      //     const data = await res.json();
      //     document.dispatchEvent(
      //       new CartUpdateEvent({}, this.sectionId, {
      //         itemCount: data.item_count,
      //         sections: data.sections,
      //         source: "recommend-toggle",
      //       })
      //     );
      //   } catch (err) {
      //     console.error("Recommend add failed:", err);
      //   } finally {
      //     btn.disabled = false;
      //     btn.classList.remove("loading");
      //   }
      // });
    });
  }

  #initWarrantyToggle() {
    // const WARRANTY_VARIANT_ID = 42681208668325;
    // const checkbox = document.getElementById("warranty-checkbox");
    // if (!checkbox) return;
    // // 🧩 Remove previous listener before re-adding (safe rebind)
    // checkbox.removeEventListener("change", this._handleWarrantyChange);
    // // ✅ Define handler once if not already
    // if (!this._handleWarrantyChange) {
    //   this._handleWarrantyChange = async (e) => {
    //     e.target.classList.add("warranty-loading");
    //     if (e.target.checked) {
    //       console.log("add");
    //       await fetch("/cart/add.js", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({
    //           items: [{ id: WARRANTY_VARIANT_ID, quantity: 1 }],
    //           sections: this.sectionId,
    //           sections_url: window.location.pathname,
    //         }),
    //       })
    //         .then((r) => r.json())
    //         .then((response) => {
    //           document.dispatchEvent(
    //             new CartUpdateEvent({}, this.sectionId, {
    //               itemCount: response.item_count,
    //               sections: response.sections,
    //               source: "warranty-toggle",
    //             })
    //           );
    //         });
    //     } else {
    //       console.log("remove");
    //       const cart = await fetch("/cart.js").then((r) => r.json());
    //       const idx = cart.items.findIndex((i) => i.id === WARRANTY_VARIANT_ID);
    //       if (idx > -1) {
    //         const line = idx + 1;
    //         await this.updateQuantityAsync({
    //           line,
    //           quantity: 0,
    //           action: "clear",
    //         });
    //       }
    //     }
    //   };
    // }
    // // ✅ Rebind safely (always only one active listener)
    // checkbox.addEventListener("change", this._handleWarrantyChange);
    // // Sync checked state on load
    // fetch("/cart.js")
    //   .then((r) => r.json())
    //   .then((cart) => {
    //     checkbox.checked = cart.items.some((i) => i.id === WARRANTY_VARIANT_ID);
    //   });
  }

  //   #initWarrantyToggle() {
  //   const WARRANTY_VARIANT_ID = 42681208668325;
  //   const checkbox = document.getElementById("warranty-checkbox");
  //   if (!checkbox) return;

  //   const self = this; // 👈 Save reference to the class instance

  //   // Remove previous listener
  //   checkbox.removeEventListener("change", self._handleWarrantyChange);

  //   // Define handler once
  //   if (!self._handleWarrantyChange) {
  //     self._handleWarrantyChange = async (e) => {
  //       $('body').addClass('cartLoaderActive');
  //       e.target.classList.add("warranty-loading");

  //       if (e.target.checked) {
  //         console.log("add");
  //         await fetch("/cart/add.js", {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({
  //             items: [{ id: WARRANTY_VARIANT_ID, quantity: 1 }],
  //             sections: self.sectionId,
  //             sections_url: window.location.pathname,
  //           }),
  //         })
  //           .then((r) => r.json())
  //           .then((response) => {
  //             document.dispatchEvent(
  //               new CartUpdateEvent({}, self.sectionId, {
  //                 itemCount: response.item_count,
  //                 sections: response.sections,
  //                 source: "warranty-toggle",
  //               })
  //             );
  //             setTimeout(() => $('body').removeClass('cartLoaderActive'), 1000);
  //           });
  //       } else {
  //         console.log("remove");
  //         const cart = await fetch("/cart.js").then((r) => r.json());
  //         const idx = cart.items.findIndex((i) => i.id === WARRANTY_VARIANT_ID);
  //         if (idx > -1) {
  //           const line = idx + 1;
  //           await self.updateQuantityAsync({
  //             line,
  //             quantity: 0,
  //             action: "clear",
  //           });
  //         }
  //         setTimeout(() => $('body').removeClass('cartLoaderActive'), 1000);
  //       }
  //     };
  //   }

  //   // Rebind checkbox listener
  //   checkbox.addEventListener("change", self._handleWarrantyChange);

  //   // ✅ Label / right side click
  //   $('body').on('click', '.warranty-right', function () {
  //     // Instead of re-adding listener, just trigger change event manually
  //     checkbox.checked = !checkbox.checked;
  //     checkbox.dispatchEvent(new Event("change", { bubbles: true }));
  //   });

  //   // Sync checked state on load
  //   fetch("/cart.js")
  //     .then((r) => r.json())
  //     .then((cart) => {
  //       checkbox.checked = cart.items.some((i) => i.id === WARRANTY_VARIANT_ID);
  //     });
  // }

  #initupsellToggle() {
    const UPSELL_VARIANT_ID = 44152478957733; // replace with your ID
    const checkbox = document.getElementById("upsell-checkbox");
    if (!checkbox) return;

    // Sync checked state on load
    getCart().then((cart) => {
      checkbox.checked = cart.items.some((i) => i.id === UPSELL_VARIANT_ID);
    });

    checkbox.addEventListener("change", async (e) => {
      if (e.target.checked) {
        // Add warranty

        console.log("add");
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: UPSELL_VARIANT_ID, quantity: 1 }],
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((response) => {
            document.dispatchEvent(
              new CartUpdateEvent({}, this.sectionId, {
                itemCount: response.item_count,
                sections: response.sections,
                source: "warranty-toggle",
              }),
            );
          });
      } else {
        // Remove warranty via built-in update
        console.log("remove");
        const cart = await getCart();
        const idx = cart.items.findIndex((i) => i.id === UPSELL_VARIANT_ID);
        if (idx > -1) {
          const line = idx + 1;
          await this.updateQuantityAsync({
            line,
            quantity: 0,
            action: "clear",
          });
        }
      }
    });
  }

  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */
  #onQuantityChange(event) {
    const { quantity, cartLine: line } = event.detail;
    document.querySelectorAll(".skeletonMine").forEach((el) => {
      el.classList.add("hide");
    });
    if (!line) return;

    if (quantity === 0) {
      document.body.classList.add("cartLoaderActive");
      return this.onLineItemRemove(line);
    }

    this.updateQuantity({
      line,
      quantity,
      action: "change",
    });
    const lineItemRow = this.refs.cartItemRows[line - 1];
    if (!lineItemRow) return;

    const textComponent = /** @type {TextComponent | undefined} */ (
      lineItemRow.querySelector("text-component")
    );
    textComponent?.shimmer();
  }

  /**
   * Handles the line item removal.
   * @param {number} line - The line item index.
   */
  onLineItemRemove(line) {
    document.querySelectorAll(".skeletonMine").forEach((el) => {
      el.classList.add("hide");
    });
    this.updateQuantity({
      line,
      quantity: 0,
      action: "clear",
    });
    const cartItemRowToRemove = this.refs.cartItemRows[line - 1];
    if (!cartItemRowToRemove) return;

    const rowsToRemove = [
      cartItemRowToRemove,
      // Get all nested lines of the row to remove
      ...this.refs.cartItemRows.filter(
        (row) => row.dataset.parentKey === cartItemRowToRemove.dataset.key,
      ),
    ];

    // Add class to the row to trigger the animation
    rowsToRemove.forEach((row) => {
      const remove = () => row.remove();

      if (prefersReducedMotion()) return remove();

      row.style.setProperty("--row-height", `${row.clientHeight}px`);
      row.classList.add("removing");

      // Remove the row after the animation ends
      onAnimationEnd(row, remove);
    });
  }

  /**
   * Updates the quantity.
   * @param {Object} config - The config.
   * @param {number} config.line - The line.
   * @param {number} config.quantity - The quantity.
   * @param {string} config.action - The action.
   */
  updateQuantity(config) {
    const cartPerformaceUpdateMarker = cartPerformance.createStartingMarker(
      `${config.action}:user-action`,
    );
    setTimeout(function () {
      document.querySelectorAll(".skeletonMine").forEach((el) => {
        el.classList.add("hide");
      });
    }, 5000);
    this.#disableCartItems();

    const { line, quantity } = config;
    const { cartTotal } = this.refs;

    const cartItemsComponents = document.querySelectorAll(
      "cart-items-component",
    );
    const sectionsToUpdate = new Set([this.sectionId]);
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    });

    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: Array.from(sectionsToUpdate).join(","),
      sections_url: window.location.pathname,
    });

    cartTotal?.shimmer();

    fetch(`${Theme.routes.cart_change_url}`, fetchConfig("json", { body }))
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const parsedResponseText = JSON.parse(responseText);

        resetShimmer(this);

        if (parsedResponseText.errors) {
          this.#handleCartError(line, parsedResponseText);
          return;
        }

        const newSectionHTML = new DOMParser().parseFromString(
          parsedResponseText.sections[this.sectionId],
          "text/html",
        );

        // Grab the new cart item count from a hidden element
        const newCartHiddenItemCount = newSectionHTML.querySelector(
          '[ref="cartItemCount"]',
        )?.textContent;
        const newCartItemCount = newCartHiddenItemCount
          ? parseInt(newCartHiddenItemCount, 10)
          : 0;

        this.dispatchEvent(
          new CartUpdateEvent({}, this.sectionId, {
            itemCount: newCartItemCount,
            source: "cart-items-component",
            sections: parsedResponseText.sections,
          }),
        );

        morphSection(
          this.sectionId,
          parsedResponseText.sections[this.sectionId],
        );
        console.log(11);
        document.querySelectorAll(".skeletonMine").forEach((el) => {
          el.classList.add("hide");
        });
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.#enableCartItems();
        cartPerformance.measureFromMarker(cartPerformaceUpdateMarker);
        setTimeout(function () {
          checkAndClearCart();
        }, 1000);
        setTimeout(
          () =>
            enforceSubscriptionQuantityRule({ trigger: "quantity-finally" }),
          1000,
        );
        // setTimeout(() => removeFreePdfIfNoPaidItems(), 1000);
      });
  }

  // Promise wrapper that resolves on the next cart update from our component
  updateQuantityAsync(config) {
    return new Promise((resolve, reject) => {
      const onUpdate = (e) => {
        // only resolve on cart updates (any source). If you want to restrict, check e.detail?.source
        document.removeEventListener(ThemeEvents.cartUpdate, onUpdate);
        resolve(e);
      };
      document.addEventListener(ThemeEvents.cartUpdate, onUpdate, {
        once: true,
      });

      try {
        this.updateQuantity(config);
      } catch (err) {
        document.removeEventListener(ThemeEvents.cartUpdate, onUpdate);
        reject(err);
      }

      // safety timeout
      setTimeout(() => {
        document.removeEventListener(ThemeEvents.cartUpdate, onUpdate);
        reject(new Error("updateQuantityAsync timed out"));
      }, 10000);
    });
  }

  /**
   * Handles the discount update.
   * @param {DiscountUpdateEvent} event - The event.
   */
  handleDiscountUpdate = (event) => {
    this.#handleCartUpdate(event);
  };

  /**
   * Handles the cart error.
   * @param {number} line - The line.
   * @param {Object} parsedResponseText - The parsed response text.
   * @param {string} parsedResponseText.errors - The errors.
   */
  #handleCartError = (line, parsedResponseText) => {
    const quantitySelector = this.refs.quantitySelectors[line - 1];
    const quantityInput = quantitySelector?.querySelector("input");

    if (!quantityInput) throw new Error("Quantity input not found");

    quantityInput.value = quantityInput.defaultValue;

    const cartItemError = this.refs[`cartItemError-${line}`];
    const cartItemErrorContainer = this.refs[`cartItemErrorContainer-${line}`];

    if (!(cartItemError instanceof HTMLElement))
      throw new Error("Cart item error not found");
    if (!(cartItemErrorContainer instanceof HTMLElement))
      throw new Error("Cart item error container not found");

    cartItemError.textContent = parsedResponseText.errors;
    cartItemErrorContainer.classList.remove("hidden");
  };

  /**
   * Handles the cart update.
   *
   * @param {DiscountUpdateEvent | CartUpdateEvent | CartAddEvent} event
   */
  #handleCartUpdate = (event) => {
    if (event instanceof DiscountUpdateEvent) {
      console.log(22);
      return;
    }
    if (event.target === this) return;

    const cartItemsHtml = event.detail.data.sections?.[this.sectionId];
    if (cartItemsHtml) {
      morphSection(this.sectionId, cartItemsHtml);
      console.log(33);
      document.querySelectorAll(".skeletonMine").forEach((el) => {
        el.classList.add("hide");
      });
    } else {
      sectionRenderer.renderSection(this.sectionId, { cache: false });
      console.log(44);
      setTimeout(function () {
        document.querySelectorAll(".skeletonMine").forEach((el) => {
          el.classList.add("hide");
        });
      }, 3000);
    }

    // 🔑 Re-init warranty toggle after every cart update
    this.#initWarrantyToggle();
    this.#initupsellToggle();
    this.#initRecommendToggle();
    // setTimeout(() => removeFreePdfIfNoPaidItems(), 500);
  };

  /**
   * Disables the cart items.
   */
  #disableCartItems() {
    this.classList.add("cart-items-disabled");
  }

  /**
   * Enables the cart items.
   */
  #enableCartItems() {
    this.classList.remove("cart-items-disabled");
  }

  /**
   * Gets the section id.
   * @returns {string} The section id.
   */
  get sectionId() {
    const { sectionId } = this.dataset;

    if (!sectionId) throw new Error("Section id missing");

    return sectionId;
  }
}

if (!customElements.get("cart-items-component")) {
  customElements.define("cart-items-component", CartItemsComponent);
}

window.handleRecommendClick = async (btn, variantId) => {
  if (!variantId || !btn) return;
  const useSkeletonLoader = !btn.closest(
    "[data-micro-upsell], .cart-drawer-triggered-upsell",
  );
  if (useSkeletonLoader) $("body").addClass("cartLoaderActive");
  btn.disabled = true;
  btn.classList.add("loading");
  // Simulate async operation (e.g., Add to Cart API)
  setTimeout(() => {
    // Example: remove loading after operation
    btn.classList.remove("loading");
  }, 2000);

  // Subscription upsell: button carries data-selling-plan when the trigger
  // product is in the cart as a subscription. Plain one-time add otherwise.
  const item = { id: parseInt(variantId), quantity: 1 };
  if (btn.dataset.sellingPlan) {
    item.selling_plan = parseInt(btn.dataset.sellingPlan);
  }

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [item],
        sections: document.querySelector("cart-items-component")?.dataset
          .sectionId,
        sections_url: window.location.pathname,
      }),
    });

    const data = await res.json();

    document.dispatchEvent(
      new CustomEvent("cart:update", {
        detail: {
          data: {
            itemCount: data.item_count,
            sections: data.sections,
            source: "recommend-toggle",
          },
        },
      }),
    );
    setTimeout(function () {
      if (useSkeletonLoader) $("body").removeClass("cartLoaderActive");
    }, 1000);
  } catch (err) {
    if (useSkeletonLoader) $("body").removeClass("cartLoaderActive");
    console.error("Recommend add failed:", err);
  } finally {
    btn.disabled = false;
    btn.classList.remove("loading");
    if (useSkeletonLoader) $("body").removeClass("cartLoaderActive");
  }
};
